import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Instant scroll so the new route is visible immediately (smooth scroll felt like the old page was still showing).
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
